// src
import * as actions from "actions/system";

const DEFAULT_STATE = {
  isHydrated: false,
  idleSince: null,
  showNetworkError: false,
};

export default (state = DEFAULT_STATE, { type }) => {
  // order actions by frequency
  switch (type) {
    case actions.hydrateSuccess.toString(): {
      return { ...state, isHydrated: true };
    }
    case actions.appGoesActive.toString(): {
      return { ...state, idleSince: null };
    }
    case actions.appGoesIdle.toString(): {
      return {
        ...state,
        idleSince: Date.now(),
      };
    }
    case actions.networkError.toString(): {
      return {
        ...state,
        showNetworkError: true,
      };
    }
    case actions.discardNetworkError.toString(): {
      return {
        ...state,
        showNetworkError: false,
      };
    }
    default:
      return state;
  }
};
